import React, { useState } from "react";
import { Box, Button, Flex, Image, Input, Link, Text } from "@chakra-ui/react";
import { PRIMARY_COLOR } from "../../constants/colors";
import api from "../../services/api";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { resolveCatalogContext, buildLoginPath } from "../../utils/catalogContext";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const navigate = useNavigate();
  const params = useParams();
  const { clientHash, sellerId } = resolveCatalogContext(params);

  const goToLogin = () => navigate(buildLoginPath(clientHash, sellerId));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await api.post("/login/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(
        err.response?.data?.error ??
          "Erro ao solicitar recuperação de senha, tente novamente mais tarde!",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Flex
      minH="100vh"
      align="center"
      justify="center"
      bg="gray.50"
      p={4}
      flexDirection="column"
      gap="40px"
    >
      <Image src="/logo-aqvex.png" cursor="pointer" width="200px" />
      <Box
        bg="white"
        rounded="lg"
        boxShadow="lg"
        p={{ base: 6, md: 10 }}
        width={{ base: "100%", sm: "420px" }}
      >
        {sent ? (
          <Flex flexDirection="column" width="100%" gap="16px" textAlign="center">
            <Text fontWeight="600" fontSize="lg">
              Verifique seu email
            </Text>
            <Text fontSize="sm" color="gray.600">
              Se o email informado estiver cadastrado, você receberá em breve
              as instruções para redefinir sua senha.
            </Text>
            <Button backgroundColor={PRIMARY_COLOR} color="white" onClick={goToLogin}>
              Voltar para o login
            </Button>
          </Flex>
        ) : (
          <Box as="form" onSubmit={handleSubmit}>
            <Flex flexDirection="column" width="100%" gap="10px">
              <Text fontWeight="600">Esqueceu sua senha?</Text>
              <Text fontSize="sm" color="gray.600" mb={2}>
                Informe seu email de cadastro para receber as instruções de
                recuperação de senha.
              </Text>
              <Flex flexDirection="column" gap="10px">
                <Text fontWeight="600">Email de Cadastro *</Text>
                <Input
                  type="email"
                  placeholder="Digite seu email..."
                  padding="15px"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Flex>
              <Button
                type="submit"
                loading={isSubmitting}
                width="100%"
                backgroundColor={PRIMARY_COLOR}
                color="white"
              >
                Enviar instruções
              </Button>
              <Text textAlign="center" fontSize="sm" mt={2}>
                <Link
                  color={PRIMARY_COLOR}
                  fontWeight="600"
                  cursor="pointer"
                  onClick={goToLogin}
                >
                  Voltar para o login
                </Link>
              </Text>
            </Flex>
          </Box>
        )}
      </Box>
    </Flex>
  );
}
